module.exports = __webpack_public_path__ + "img/swiper1.df609bcb.webp";